import { Box, CircularProgress } from '@mui/material';
import { FC, PropsWithChildren } from 'react';
import { useLocation } from 'react-router-dom';
import { tokenKey } from '../services';
import { useGetAuthQuery } from '../services/auth';
import { LoginPage } from './LoginPage';

export const Authentication: FC<PropsWithChildren> = ({ children }) => {
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const token = params.get(tokenKey);
  token && localStorage.setItem(tokenKey, token);

  const { isLoading, isError } = useGetAuthQuery();

  if (isLoading)
    return (
      <Box display="flex" justifyContent="center" alignItems="center" width="100%">
        <CircularProgress size="48px" />
      </Box>
    );
  if (isError) {
    localStorage.removeItem(tokenKey); // remove expired token
    history.pushState({}, '', location.pathname); // remove token from search params
    return <LoginPage />;
  }

  return children;
};
